"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVerticalAlign = void 0;
function getVerticalAlign(state, defaultAlign = 'bottom') {
    const { view: { verticalAlign, spectra: { activeTab }, }, } = state;
    return verticalAlign?.[activeTab] || defaultAlign;
}
exports.getVerticalAlign = getVerticalAlign;
